import { render, staticRenderFns } from "./forgetpwd.vue?vue&type=template&id=6d856f34&scoped=true&"
import script from "./forgetpwd.vue?vue&type=script&lang=js&"
export * from "./forgetpwd.vue?vue&type=script&lang=js&"
import style0 from "./forgetpwd.vue?vue&type=style&index=0&id=6d856f34&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d856f34",
  null
  
)

export default component.exports